<template>
  <span
    class="om-hairline-surround"
    :class="b({
      mark,
      plain,
      round,
      [type]: type,
      [size]: size
    })"
  >
    <slot />
  </span>
</template>

<script>
import create from '../utils/create';

export default create({
  name: 'tag',
  props: {
    type: String,
    mark: Boolean,
    plain: Boolean,
    round: Boolean,
    size: String
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/tag/index.vue